const CareerNavbar = () => {
  return (
    <>
      <div className="w-100 bg-purple-subtle">
        <div className="justify-content-start container text-start ">
          <nav className="navbar navbar-expand-lg p-2 mt-0">
            <div className="container-fluid">
              <ul className="navbar-nav gap-4 text-nowrap">
                <li className="nav-item">
                  <a
                    className="nav-link text-md fw-bold letter-spacing-1 text-black"
                    href="/WorkWithUs"
                  >
                    Work With Us
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link text-md fw-bold letter-spacing-1 text-black"
                    href="/Jobs"
                  >
                    Jobs
                  </a>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </>
  );
};

export default CareerNavbar;
